import type { Tag } from '@baseball-near-you/prisma';
import { AbstractClient, type PaginatedResponse } from './AbstractFetchClient';

export class TagClient extends AbstractClient {
  getAllTags = this.get<PaginatedResponse<Tag[]>, Record<string, never>>('');

  getTag = this.get<Tag, { args: { id: string } }>(({ id }) => `/${id}`);
}
